<template>
    <el-dialog title="机构Logo" :visible.sync="centerDialogVisible" :close-on-click-modal="false" width="600px" class="setLogo">
        <ShopLocalCropper :cropperOption="cropperOption" ref="localCropper" @setImage="_setImage" :uploadType="uploadType"></ShopLocalCropper>
        <div class="shopLogoBox">
            <p class="name">机构Logo</p>
            <div class="upload cover-image" @click="openDialog">
                <div class="avatar-uploader">
                    <div class="el-upload el-upload--text">
                        <img class="uploadImgIcon" :src="require('@/common/images/other/upload.png')" v-if="!img" alt="">
                        <img :src="img.furl +'?'+timestamp" alt="" class="uploadImg" v-else-if="img.furl && img.furl +'?' + timestamp">
                        <img :src="img" alt="" class="uploadImg" v-else>
                    </div>
                    <div class="el-upload__tip">图片格式为:bmp, jpeg, jpg, gif,尺寸1：1,不可大于1M</div>
                </div>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="centerDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="comfirm">确 定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import ShopLocalCropper from 'base/cropper/shopLocalCropper'
import {mapGetters, mapActions} from 'vuex'
import {updateShopSet, uploadShopLogo} from 'api/accountApi'
export default {
    name: 'shopLogo',
    data() {
        return {
            centerDialogVisible: false,
            img: '',
            timestamp: new Date().getTime(),
            uploadType: {
                catecode: '95',
                datatype: 'IMAGE'
            },
            cropperOption: {
                fixedNumber: [200, 200], // 截图框的宽高比例
                enlarge: 2.5, // 图片根据截图框输出比例倍数
                autoCropWidth: 200, // 默认生成截图框宽度
                autoCropHeight: 200 // 默认生成截图框高度
            }
        }
    },
    props: ['data'],
    methods: {
        open() {
            this.centerDialogVisible = true
            this.img = this.data.shoplogourl
        },
        openDialog() {
            this.$refs.localCropper.openDialog()
        },
        _setImage(file) {
            this.timestamp = new Date().getTime()
            this.img = file
            console.log(this.img)
        },
        close() {
        },
        comfirm() {
            if (this.img) {
                if (this.img.furl || this.img) {
                    // delete this.img.type
                    // this.img = JSON.stringify(this.img)
                } else {
                    this.img = ''
                    return
                }
                let options = {
                    shoplogourl: this.img.furl ? this.img.furl : this.data.shoplogourl,
                    shoplogoid: this.img.key ? this.img.key : this.data.shoplogoid
                }
                this.setLoading(true)
                console.log(this.img)
                uploadShopLogo({
                    data: options,
                    success: data => {
                        this.setLoading(false)
                        this.centerDialogVisible = false
                        this.$message.success('设置成功')
                        this.$emit('setLogo', options)
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            } else {
                this.$message.error('请上传店铺logo')
            }
        },
        ...mapActions([
            'setLoading'
        ])
    },
    components: {
        ShopLocalCropper
    },
    watch: {
        'data': {
            handler(newV) {
                if (newV) {
                    
                    console.log(this.img)
                }
            }
        },
        deep: true
    }
}
</script>
<style lang="scss">
    .setLogo{
        .shopLogoBox{
            display: flex;
            justify-content: space-between;
            .name {
                width: 120px;
            }
            .upload{
                .avatar-uploader{
                    display: flex;
                    .el-upload{
                        width: 110px;
                        height: 110px;
                        margin-right: 10px;
                        background: #F5F7FA;
                        line-height: 110px;
                        text-align: center;
                        .uploadImgIcon{
                            width: 21px;
                            height: 21px;
                        }
                        .uploadImg{
                            width: 110px;
                            height: 110px;
                        }
                    }
                    .el-upload__tip{
                        color: #C0C4CC;
                        font-size: 14px;
                    }
                }
            }
        }
    }
</style>
